/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { pushEvent } from '@nykaa/data-layer';
import doLogin from '@nykaa/auth-shared/store/actions/login';
import PasswordInput from '@nykaa/auth/components/PasswordLogin';
import Toast, { VARIANT } from '@nykaa/ui-components/Toast';
import { logger } from '@nykaa/logger';
import {
  checkOriginMobile,
  getLoginWelcomeMessage,
  handleShareEvent,
} from '@nykaa/auth-shared/utils';
import {
  SUBTITLES,
  TNC_URL,
  CUSTOMER_ID,
  TOAST_TIMER,
  LOGINTYPE,
  SHARE_EVENTS,
  AUTH_EVENTS,
} from '@nykaa/auth-shared/constants';
import { PasswordLoginProps } from '@nykaa/auth-shared/store/types';
import {
  SOMETHING_WENT_WRONG,
  API_PARAM_KEYS,
} from '@nykaa/auth-shared/store/constants';
import useAuthData from '@nykaa/auth-shared/hooks/useAuthData';
import useVerificationSwitch from '@nykaa/auth-shared/hooks/useVerificationSwitch';
import { setAuthSteps } from 'shared/helpers/auth';
import { userSessionTypes } from 'shared/constants';
import { fetchAuth } from 'shared/store/auth/action';
import { removeAuthFromStorage } from 'store/auth/helper';
import { executeCaptcha } from 'helpers/utils/reCaptcha';
import { recaptchaActions } from 'User/store/resetPassword/actionTypes';
import { VerifyScreenProps } from 'layouts/Auth/types';
import { State } from 'store/types';
import { hideSignUp } from 'store/app/actions';
import { pushBuyNowClicked } from 'layouts/Product/Actions/helper';
import { CAPTCHA_ERROR } from 'constants/auth';

const PasswordLogin = ({ setSuccessMessage, showNudge }: VerifyScreenProps) => {
  const { mobile, error, email, isApiError, message, selectedCustomerId } =
    useAuthData() || {};
  const isLoginCaptchaEnabled = useSelector(
    (state: State) => state.remoteConfig.configs.configFlags?.loginCaptcha
  );

  const [isError, setError] = useState(error);
  const [errorMessage, setErrorMessage] = useState(message);

  const [toastError, setToastError] = useState(isApiError);
  const [toastMsg, setToastMsg] = useState(message);

  const { handleSwitch } = useVerificationSwitch(true);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    setToastError(isApiError);
    setToastMsg(message);
  }, [isApiError]);

  useEffect(() => {
    setError(error);
    setErrorMessage(message);
  }, [error]);

  const handleDoLogin = (params: PasswordLoginProps) => {
    removeAuthFromStorage();
    doLogin(params)(dispatch).then((response) => {
      const { success, firstname } = response || {};
      const loginType = checkOriginMobile(origin)
        ? LOGINTYPE.PHONE
        : LOGINTYPE.EMAIL;
      if (success) {
        setAuthSteps(4);
        handleShareEvent(SHARE_EVENTS.login, dispatch);
        setTimeout(() => {
          fetchAuth()(dispatch).then(() => {
            if (showNudge) {
              dispatch(hideSignUp(history));
              pushBuyNowClicked(false);
            }
            pushEvent(AUTH_EVENTS.LOGIN_SUCCESS, {
              loginType,
              loginStatus: userSessionTypes.LOGGED_IN,
            });
          });
        }, 500);
        setSuccessMessage(getLoginWelcomeMessage(firstname));
      } else {
        setError(true);
        setErrorMessage(response?.message || SOMETHING_WENT_WRONG);
      }
    });
  };

  const handleLogin = (password: string) => {
    const { mobileNumber, userName } = API_PARAM_KEYS;
    setToastError(false);
    setError(false);
    let fieldName = userName;
    let fieldValue = email;

    if (selectedCustomerId) {
      fieldName = CUSTOMER_ID;
      fieldValue = selectedCustomerId;
    } else if (checkOriginMobile(origin)) {
      (fieldName = mobileNumber), (fieldValue = mobile);
    }
    let params: PasswordLoginProps = {
      [fieldName]: fieldValue,
      password,
    };
    if (isLoginCaptchaEnabled) {
      executeCaptcha(recaptchaActions.LOGIN)
        .then((token: string) => {
          const captchaParams = {
            captchaResponse: token,
          };
          params = {
            ...captchaParams,
            ...params,
          };
          handleDoLogin(params);
        })
        .catch((err: Error) => {
          setToastError(true);
          setToastMsg(SOMETHING_WENT_WRONG);
          logger.error(err, CAPTCHA_ERROR);
        });
    } else handleDoLogin(params);
  };
  const inputError = isError || error ? errorMessage : '';

  return (
    <>
      <PasswordInput
        subTitle={SUBTITLES.password}
        switchBtnCallback={handleSwitch}
        onSubmit={handleLogin}
        origin={origin}
        error={inputError}
        tncUrl={TNC_URL}
        isNudge={showNudge}
      />
      {toastError && (
        <Toast
          timer={TOAST_TIMER}
          variant={VARIANT.single}
          message={toastMsg}
        />
      )}
    </>
  );
};

export default PasswordLogin;
